import { render, staticRenderFns } from "./NewRegistry.vue?vue&type=template&id=63813948&scoped=true&"
import script from "./NewRegistry.vue?vue&type=script&lang=js&"
export * from "./NewRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63813948",
  null
  
)

export default component.exports